// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2konO","col":"styles_col__3juDM"};